export const navLinksdata = [
    {
      _id: 1001,
      title: "Home",
      link: "home",
    },
    {
      _id: 1002,
      title: "About",
      link: "about",

    },
    {
      _id: 1003,
      title: "Services",
      link: "services",
    },
    {
      _id: 1004,
      title: "Work",
      link: "work",
    },
    {
      _id: 1006,
      title: "Contact",
      link: "contact",
    },
  ];